import React, { useEffect, useState } from "react";
import "../commomComponents/hamburger.css";
import {
  ArrowDownIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@chakra-ui/icons";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ResponsiveDialog from "./Dialog";

export default function Hamburger() {
  const [submenuVisible, setSubmenuVisible] = useState(false);

  const toggleSubmenu = () => {
    setSubmenuVisible(!submenuVisible);
  };
  const [isMenuVisible, setMenuVisibility] = useState(false);
  const [isMenuVisible1, setMenuVisibility1] = useState(false);
  const [isMenuVisible2, setMenuVisibility2] = useState(false);

  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const history = useHistory();

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const ScrollToTop = ({ history }) => {
    const scrollToTop = () => {
      window.scrollTo(0, 2500);
    };

    useEffect(() => {
      // Scroll to the top when the component mounts or updates
      scrollToTop();
    }, [history.location.pathname]);
  };
  useEffect(() => {
    // Scroll to the top when the component mounts or updates
    window.scrollTo(0, 0);
  }, [history.location.pathname]);

  const hideMenu = () => {
    setMenuOpen(false);
  };

  // Function to toggle the visibility of menu items
  const toggleMenu = () => {
    setMenuVisibility(!isMenuVisible);
  };
  const toggleMenu1 = () => {
    setMenuVisibility1(!isMenuVisible1);
  };

  const toggleMenu2 = () => {
    setMenuVisibility2(!isMenuVisible2);
  };
  return (
    <div class="hamburger-menu">
      {openDialog && (
        <ResponsiveDialog open={openDialog} handleClose={handleClose} />
      )}
      <input
        id="menu__toggle"
        type="checkbox"
        checked={menuOpen}
        onChange={() => setMenuOpen(!menuOpen)}
      />
      <label className="menu__btn" htmlFor="menu__toggle">
        <span></span>
      </label>
      <ul className="menu__box">
        <li>
          <Link class="menu__item" to="/" onClick={hideMenu}>
            Home
          </Link>
        </li>
        <li>
          <Link class="menu__item" to="/about-us" onClick={hideMenu}>
            About Us
          </Link>
        </li>
        <li
          className="menu__item"
          style={{ cursor: "pointer" }}
          onClick={toggleMenu1}
        >
          Offerings {!isMenuVisible1 ? <ChevronDownIcon /> : <ChevronUpIcon />}{" "}
        </li>

        {isMenuVisible1 && (
          <>
            <li>
              <Link
                className="menu__item"
                to="/portfolio-management-service"
                onClick={hideMenu}
              >
                PMS
              </Link>
            </li>
            <li>
              <Link
                className="menu__item"
                to="/alternative-investment-funds"
                onClick={hideMenu}
              >
                AIF
              </Link>
            </li>
          </>
        )}
        {/* <li><a class="menu__item" href="/portfolio-management-service">PMS Strategies</a></li> */}
        {/* <li className="menu_heading">PMS Strategies</li>
                <li><a class="menu__item" href="/portfolio-management-service/contrarian-investing">Contra Strategy</a></li>
                <li><a class="menu__item" href="/portfolio-management-service/flexicap">Flexicap Strategy</a></li>
                <li><a class="menu__item" href="/portfolio-management-service/value-strategy">Value Strategy</a></li>
                <li><a class="menu__item" href="/portfolio-management-service/largecap-strategy">Largecap Strategy</a></li>
                <li><a class="menu__item" href="/portfolio-management-service/pipe-pms">PIPE Strategy</a></li> */}
        {/* <li className="menu_heading">AIF</li> */}
        {/* <li><a class="menu__item" href="/InvestWithUs">Invest Now</a></li> */}
        <li>
          <Link class="menu__item" to="/investors-corner" onClick={hideMenu}>
            Investor Corner
          </Link>
        </li>
        <li>
          <Link class="menu__item" to="/market-insights" onClick={hideMenu}>
            Insights
          </Link>
        </li>
        {/* <li><a class="menu__item" href="/Faqs">FAQs</a></li> */}
        {/* <li><a class="menu__item" href="/ContactUs">Contact Us</a></li> */}
        <li
          className="menu__item"
          style={{ cursor: "pointer" }}
          onClick={toggleMenu}
        >
          Invest Now{!isMenuVisible ? <ChevronDownIcon /> : <ChevronUpIcon />}{" "}
        </li>

        {isMenuVisible && (
          <>
            <li>
              <Link
                className="menu__item"
                to="/existing-investor"
                onClick={hideMenu}
              >
                Existing Investor
              </Link>
            </li>
            <li>
              <Link
                className="menu__item"
                to="/invest-with-us"
                onClick={hideMenu}
              >
                New Investor
              </Link>
            </li>
          </>
        )}
        <li>
          <a
            class="menu__item"
            href="/investors-corner#InvestorGrievance"
            onClick={() => {
              hideMenu();
              ScrollToTop();
            }}
          >
            Investor Grievance
          </a>
        </li>
        <li
          className="menu__item"
          style={{ cursor: "pointer" }}
          onClick={toggleMenu2}
        >
          Login {!isMenuVisible2 ? <ChevronDownIcon /> : <ChevronUpIcon />}{" "}
        </li>
        {isMenuVisible2 && (
          <>
            <li>
              <a
                className="menu__item"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  hideMenu();
                  setMenuVisibility2(false);
                  handleClickOpen();
                }}
              >
                PMS
              </a>
            </li>
            <li>
              <a
                className="menu__item"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  hideMenu();
                  setMenuVisibility2(false);
                  window.open(
                    "https://apps.iciciprupms.com/VCF_AIF_WEB?Flag=E"
                  );
                }}
              >
                AIF
              </a>
            </li>
          </>
        )}
        {/* <li><a class="menu__item" href="https://iciciprualternates.com/portal/">Login</a></li> */}
        {/* <li><div class="divider"></div></li>
                <li><a class="menu__item" href="/InvestWithUs">Invest with Us Directly</a></li>
                <li><a class="menu__item" href="/OpenAnAccount">Open an Account Now</a></li> */}
      </ul>
    </div>
  );
}
